module.exports = __webpack_public_path__ + "stylesheets/light-landing_6dac39b95486422158c23a8539f18407.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/light-landing.less
// module id = hqwK
// module chunks = 153